import { Box, BoxProps } from '@material-ui/core';

import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface SectionTitleProps {
  subtitle?: string;
  title?: string;
  titleDynamicDataTexts?: string[];
  subtitleDynamicDataTexts?: string[];
  boxProps?: BoxProps;
}

export const SectionTitle = ({
  subtitle,
  title,
  titleDynamicDataTexts,
  subtitleDynamicDataTexts,
  boxProps,
}: SectionTitleProps) => {
  return (
    <Box mb={3} {...boxProps}>
      {title && (
        <Font variant={'h3'} color={'title'}>
          <Text tId={title} dynamicDataTexts={titleDynamicDataTexts} />
        </Font>
      )}
      {subtitle && (
        <Box pt={1}>
          <Font variant={'body2'} color={'textSecondary'}>
            <Text tId={subtitle} dynamicDataTexts={subtitleDynamicDataTexts} />
          </Font>
        </Box>
      )}
    </Box>
  );
};
